import { render, staticRenderFns } from "./WorkspacesView.vue?vue&type=template&id=4955118f&"
import script from "./WorkspacesView.vue?vue&type=script&lang=ts&"
export * from "./WorkspacesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports